import { MODAL_OPEN, MODAL_CLOSE, MODAL_REPLACE_ALL } from '../actions/actionTypes.js';


const initialState = [];

export const modals = (state = initialState, action) => {
  switch (action.type) {
    case MODAL_OPEN: {
      return [...state, action.payload]
    }
    case MODAL_CLOSE: {
      return [...state.slice(0, -1)]
    }
    case MODAL_REPLACE_ALL: {
      return [action.payload]
    }
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/modals.js